import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { EndUserAuthService } from './end-user-auth.service';

export const endUserAuthGuard: CanActivateFn = () => {
  const auth = inject(EndUserAuthService);
  const router = inject(Router);
  return auth.isLoggedIn ? true : router.createUrlTree(['/']);
};
